import Joi from "joi";
import Form from "../../common/form";
import PropTypes from "prop-types";
import toast from "react-hot-toast";

import Button from "../../themed/button";
import Conditional from "../../common/conditional";

interface PMIEquipment {
    equipmentName: string;
    modal: string;
    serialNumber: string;
    calibrationDueDate: Date;
    calibrationBlockDetails: string;
}

class PMIEquipmentForm extends Form {
    state = { 
        data: {
			equipmentName: '',
            modal: '',
            serialNumber: '',
            calibrationDueDate: new Date(),
            calibrationBlockDetails: ''
		},
		errors: {},
		loading: false,
		progress: 0
    };

    schema = {
        equipmentName: Joi.string().required().label('Item Description'),
        modal: Joi.string().required().label('Identified Material Spec'),
        serialNumber: Joi.string().required().label('Serial Number'),
        calibrationBlockDetails: Joi.string().required().label('Calibration Block Details'),
        calibrationDueDate: Joi.date().greater('now').required().label('Calibration Due Date'),
    };

    static propTypes = {
        initialPMIData: PropTypes.object,
        onDeleteItem: PropTypes.func,
        onSave: PropTypes.func,
    };
    
    componentDidMount(): void {
        if (this.props.initialPMIData) {
            this.setState({ data: this.props.initialPMIData });
        }
    }

    doSubmit = () => {
        this.props.onSave(this.state.data);

        if (!this.props.initialPMIData) {
            this.setState({
                data: {
                    equipmentName: '',
                    modal: '',
                    serialNumber: '',
                    calibrationDueDate: new Date(),
                    calibrationBlockDetails: ''
                },
            })
        }

        toast.success('Saved successfully!');
    };

    render() { 
        return ( 
            <form autoComplete="off" onSubmit={this.handleSubmit}>
				<h3 className="form-title">Equipment Details</h3>

                <div className="container">
                    <div className="row">
                        <div className="col">
                            {this.renderInput({
                                type: 'text',
                                name: 'equipmentName',
                                label: 'Equipment Name',
                                placeholder: 'Enter Equipment Name',
                            })}
                        </div>
                        
                        <div className="col">
                            {this.renderInput({
                                type: 'text',
                                name: 'modal',
                                label: 'Modal',
                                placeholder: 'Enter Equipment Modal',
                            })}
                        </div>

                        <div className="col">
                            {this.renderInput({
                                type: 'text',
                                name: 'serialNumber',
                                label: 'Serial Number',
                                placeholder: 'Enter Equipment Serial Number',
                            })}
                        </div>
                    </div>
                    
                    <div className="divider my-4"></div>

                    <div className="row">
                        <div className="col">
                            {this.renderTextArea({
                                name: 'calibrationBlockDetails',
                                label: 'Calibration Block Details',
                                placeholder: 'Enter Calibration Block Details',
                            })}
                        </div>

                        <div className="col">
                            {this.renderDatePicker({
								name: 'calibrationDueDate',
								label: 'Calibration Due Date',
								placeholderText: 'Select Calibration Due Date',
								minDate: new Date(),
							})}
                        </div>
                    </div>
                </div>

                <div className="divider my-4"></div>

                <div className="d-flex justify-content-end">
                    <Conditional isVisible={!!this.props.onDeleteItem}>
                        <div className="me-3">
                            <Button
                                onClick={this.props.onDeleteItem} 
                                icon="trash"
                                type="button"
                                label="Delete" 
                                style={{ backgroundColor: 'red' }} 
                            />
                        </div>
                    </Conditional>

				    {this.renderButton('Save')}
                </div>
			</form>
        );
    }
}
 
export type { PMIEquipment };
export default PMIEquipmentForm;